import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "sonner";
import { getFileAttachementByEntityId } from "../../../api/fileAttachement";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import withPermission from "../../../core/common/autorisations/withPermission";

type Props = {
  show: boolean;
  onClose: () => void;
  course: any;
};

const CourseSupportList = ({ show, onClose, course }: Props) => {
  const [files, setFiles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchFiles = async () => {
    if (!course?.id) return;

    try {
      setLoading(true);
      const response = await getFileAttachementByEntityId(
        course.id,
        "Course",
        buildPermissionContext(Resource.COURSE_SUPPORT, Action.READ),
      );
      setFiles(response.data || []);
    } catch (error: any) {
      // console.error("Erreur lors du chargement des fichiers:", error);
      toast.error(
        error.response?.data?.message ||
          "Erreur lors du chargement des supports.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && course) {
      fetchFiles();
    } else {
      setFiles([]);
    }
  }, [show, course]);

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Supports de cours :{" "}
          {course?.label || course?.subject_name || "Détails"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center p-3">Chargement...</div>
        ) : (
          <div className="d-flex flex-column gap-2">
            {files.length === 0 ? (
              <div className="text-center text-muted p-3">
                Aucun support disponible pour ce cours.
              </div>
            ) : (
              files.map((file: any) => (
                <div
                  key={file.id}
                  className="d-flex align-items-center justify-content-between p-2 bg-light rounded"
                >
                  <div className="d-flex align-items-center overflow-hidden">
                    <i className="ti ti-file-text text-primary fs-4 me-2 flex-shrink-0" />
                    <span
                      className="text-truncate"
                      title={file.fileOriginalName}
                    >
                      {file.fileOriginalName}
                    </span>
                  </div>

                  <a
                    href={file.temporaryUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-info"
                    title="Voir"
                  >
                    <i className="ti ti-eye" />
                  </a>
                </div>
              ))
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default withPermission(
  CourseSupportList,
  [buildPermission(Resource.COURSE_SUPPORT, Action.READ)],
  "masquer",
);
